import React, { useState, useCallback, useRef } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import GooglePlacesAutocomplete from "react-google-autocomplete";
// import { GOOGLE_API } from "../../../../config";
import apiCall from "../../../../apicall";
import { useSelector } from "react-redux";
import Toast from "../../../common/toast";
import Spinner from "../../../common/spinner";
import SessionExpired from "../../../common/sessionExpired";
import EmpLocationList from "../../public-user/components/employers/empLocationList";
import { useEffect } from "react";
import CanLocationList from "./canLocation";
import SectionRecordsFilter from "../../public-user/sections/common/section-records-filter";
import { Helmet } from "react-helmet-async";
import { formatCompanyName } from "../../../../globals/fomat-comapny-name";
import { logEvent_Analytics } from "../../../common/firebase/firebase-analytics-service";
import CanAddLocationPopup from "./can-add-location";

const CanAddLocation = () => {
    const { TOKEN } = useSelector((state) => state.menu);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [locationDetails, setLocationDetails] = useState({
        locationName: "",
        address: "",
        city: "",
        country: "",
        state: "",
        zipcode: "",
        buildingNum: "",
        clientLocation: false,
        clientName: ""
    });
    const [markerPosition, setMarkerPosition] = useState(null);
    const [autocompleteInput, setAutocompleteInput] = useState("");
    const [errSuccessMesg, setErrSuccessMsg] = useState({
        message: "",
        status: "error",
    });
    const [isEditLocation, setIsEditLocation] = useState(false);
    const [tableFilter, setTableFilter] = useState({
        sortType: "createdDate",
        sortDirection: "desc",
        status: "",
        searchKey: "",
        // jobType: "",
        // applicant: "",
        // customer: "",
        // categoryType: "All",
    });
    const [locationCurrentPage, setLocationCurrentPage] = useState(1);
    const [rowLocationPerPage, setLocationRowPerPage] = useState(10);
    const [locationInfo, setLocationInfo] = useState({});
    const [paginationLocationData, setPaginationLocationData] = useState({
        totalElements: 0,
        totalPages: 0,
    });
    const [locationLoader, setLocationLoader] = useState(false);

    const displayLocationErrMsg = (errMsg) => {
        setErrSuccessMsg({
            message: errMsg,
            status: false,
        });
        setLocationInfo({});
        setPaginationLocationData({
            totalElements: 0,
            totalPages: 0,
        });
        setLocationLoader(false);
    };

    const handleRecordsLocationPerPageChange = (event) => {
        setLocationCurrentPage(1);
        setLocationRowPerPage(event.target.value);
    };

    const getLocationData = async () => {
        try {
            setLocationLoader(true);
            const api = `${`institutions/locations?offset=0&sort=${tableFilter?.sortType
                },${tableFilter?.sortDirection}&page=${locationCurrentPage - 1
                }&size=${rowLocationPerPage}`

                }`;
            const locationResponse = await apiCall(api, "GET", null, TOKEN);
            console.log("locationResponse---", locationResponse?.response?.data?.message);

            if (locationResponse?.data?.content?.length > 0) {
                setSessionExpired(false);
                setLocationInfo(locationResponse.data.content);
                setPaginationLocationData({
                    totalElements: locationResponse.data.totalElements,
                    totalPages: locationResponse.data.totalPages,
                });
                setLocationLoader(false);
            } else if (locationResponse?.data.content?.length == 0) {
                setLocationInfo({});
                setPaginationLocationData({
                    totalElements: 0,
                    totalPages: 0,
                });
                setLocationLoader(false);
            } else if (locationResponse?.response?.status == 401) {
                setSessionExpired(true);
                displayLocationErrMsg("Your session has been expired!!");
            } else {
                setSessionExpired(false);
                displayLocationErrMsg(locationResponse?.response?.data?.message);
            }
        }
        catch (err) {
            //   setSessionExpired(false);
            //   displayLocationErrMsg("Something went wrong!");
        }
    };
    useEffect(() => {
        getLocationData();
    }, [locationCurrentPage, rowLocationPerPage]);

    useEffect(() =>{
        logEvent_Analytics('location_screen_web');
    },[])

    const resetLocationState = () => {
      setLocationDetails({
        locationName: "",
        address: "",
        city: "",
        country: "",
        state: "",
        zipcode: "",
        buildingNum: "",
        clientName: "",
        clientLocation: false,
        locationId: ""
      });
    };

    const formatAddress = (address, city, state, zipCode) => {
        const parts = [address, city, state, zipCode]?.filter(Boolean);
        return parts.join(", ");
    };

    const handleSelectedLocation = (item) => {
      setIsEditLocation(true);
      const address = formatAddress(
        item?.address,
        item?.city,
        item?.state,
        item?.zipCode
      );
      setAutocompleteInput(address);
      setLocationDetails({
        locationName: item?.locationName || "",
        address: item?.address || "",
        city: item?.city || "",
        country: "",
        state: item?.state || "",
        zipcode: item?.zipCode || "",
        buildingNum: item?.suitNumber || "",
        clientName: item?.clientName || "",
        clientLocation: item?.clientName ? true : false,
        locationId: item?.id
      });
      setMarkerPosition({
        lat: item?.location?.latitude,
        lng: item?.location?.longitude,
      });
    };

    return (
        <>
        <div>
            <Helmet>
            <title>{`Location List | Add Location | Location Preferences | ${formatCompanyName()}`}</title>
            <meta name="description" content="Enhance your job listings by adding a precise location. This helps candidates understand where the job is based and increases application rates." />
            <meta name="keywords" content="add location" />
            </Helmet>
        </div>
        <div className="section-full p-t120  p-b90 site-bg-white mt-2">
        <div className="twm-right-section-panel candidate-save-job container">
        <div class="panel-heading wt-panel-heading p-a20">
            <h3 class="wt-title">Locations</h3>
          </div>
        <div className="twm-right-section-panel candidate-save-job">
            <div>
                <a
                    className="site-button"
                    data-bs-toggle="modal"
                    href={"#add_can_location_popup"}
                    role="button"
                    onClick={() => {setIsEditLocation(false); resetLocationState(); setAutocompleteInput("");}}
                >
                    Add Location
                </a>
            </div>
            <div>
                <CanLocationList
                    locationList={locationInfo}
                    locationLoader={locationLoader}
                    rowLocationPerPage={rowLocationPerPage}
                    handleRecordsLocationPerPageChange={handleRecordsLocationPerPageChange}
                    paginationLocationData={paginationLocationData}
                    locationCurrentPage={locationCurrentPage}
                    setLocationCurrentPage={setLocationCurrentPage}
                    tableFilter={tableFilter}
                    setTableFilter={setTableFilter}
                    handleSelectedLocation={handleSelectedLocation}
                />
            </div>
            <CanAddLocationPopup 
            locationDetails={locationDetails}
            setLocationDetails={setLocationDetails}
            markerPosition={markerPosition}
            setMarkerPosition={setMarkerPosition}
            autocompleteInput={autocompleteInput}
            setAutocompleteInput={setAutocompleteInput}
            isEditLocation={isEditLocation}
            resetListFunction={getLocationData}
            resetLocationState={resetLocationState}
            />
        </div>
        </div>
        </div>
        </>
    );
};

export default CanAddLocation;
